// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2594":"a3bc76e7","8092":"0fe2195c"}[chunkId] + ".chunk.css";
};